/* eslint-disable prettier/prettier */
import React from 'react';
import { useSeasons } from '../../../hooks/seasons';
import { useStandings } from '../../../hooks/standings';
import { usePlayerFilterOptions } from '../FilterOptions/PlayerFilterOptions';
import {
  translatePosition,
} from '../../../utils/translate';

function PlayersFilter({
  playersStats,
  season,
  setSeason,
  orderBy,
  setOrderBy,
  team,
  setTeam,
  position,
  setPosition,
  nationality,
  setNationality,
  setPlayerLimit,
  mobileFilters,
  setMobileFilters,
}) {
  const [seasons] = useSeasons('desc');

  const [standings] = useStandings(season, 'total');
  const [playerFilterOptions] = usePlayerFilterOptions();
  const playerNationalities = new Set().add('Alla nationaliteter');
  const playerPositions = new Set().add('Alla positioner');


  playersStats?.forEach((player) => {
    if (player.nationality) {
      playerNationalities.add(player.nationality);
    }
    if (player.position) {
      playerPositions.add(player.position);
    }
  });
  const playerTeams = Object.values(standings || {})
    .map((t) => ({
      teamAbbrv: t.teamAbbrv,
      teamDisplayName: t.teamDisplayName,
    }))
    .filter((t) => t.teamAbbrv);

  playerTeams.sort((a, b) => {
    a.teamDisplayName.toUpperCase();
    b.teamDisplayName.toUpperCase();
    return a.teamDisplayName.localeCompare(b.teamDisplayName);
  });
  playerTeams.unshift({
    teamAbbrv: 'Alla lag',
    teamDisplayName: 'Alla lag',
  });
  const labels = [];
  labels.push({
    type: setTeam,
    default: 'Alla lag',
    selection: team,
    text: team !== 'Alla lag' ? team : false,
  });
  labels.push({
    type: setPosition,
    default: 'Alla positioner',
    selection: position,
    text: position !== 'Alla positioner' ? position : false,
  });
  labels.push({
    type: setNationality,
    default: 'Alla nationaliteter',
    selection: nationality,
    text: nationality !== 'Alla nationaliteter' ? nationality : false,
  });
  labels.push({
    type: setSeason,
    default: '2024',
    selection: season,
    text: season !== '2024' ? season : false,
  }); // fix this later, add current season
  return (
    <>
      <div className="row pt-3 pb-2 d-flex d-md-none">
        <div className="col-12 col-md pe-md-1 mb-0">
          <p className="heading-h6 mb-1">Sorterat på</p>
          <div className="row">
            <div className="col-12 d-flex flex-row gap-2">
              <select
                value={orderBy}
                onChange={(e) => {
                  setOrderBy(e.target.value);
                  setPlayerLimit(20);
                }}
                className="select flex-grow-1"
              >
                {playerFilterOptions?.map((option) => (
                  <option value={option?.key}>{option?.name}</option>
                ))}
              </select>
              <a
                className="button button--primary d-block text-center"
                style={{ lineHeight: '27px' }}
                href="/"
                title="Filtrera"
                onClick={(e) => {
                  e.preventDefault();
                  setMobileFilters(!mobileFilters);
                }}
              >
                Filtrera
              </a>
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-flex flex-row gap-2 justify-content-end pill-area">
              {labels.map((item) => {
                return item?.text ? (
                  <button
                    type="button"
                    className="bg-primary-yellow selection-pill heading-h6"
                    onClick={() => {
                      item?.type(item?.default);
                    }}
                  >
                    <span style={{ paddingTop: '2px' }}>{item?.text}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <mask
                        id="mask0_3382_6818"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="25"
                      >
                        <rect
                          y="0.649658"
                          width="24"
                          height="24"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_3382_6818)">
                        <path
                          d="M8.4 17.6497L7 16.2497L10.6 12.6497L7 9.07468L8.4 7.67468L12 11.2747L15.575 7.67468L16.975 9.07468L13.375 12.6497L16.975 16.2497L15.575 17.6497L12 14.0497L8.4 17.6497Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                  </button>
                ) : (
                  ''
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={`modal-background-overlay ${
          mobileFilters
            ? 'data-filter-modal-bg-show '
            : 'data-filter-modal-bg-hide '
        }`}
        onClick={(e) => {
          e.preventDefault();
          setMobileFilters(!mobileFilters);
        }}
      />
      <div
        className={`data-filter-modal ${
          mobileFilters ? 'data-filter-modal-show' : 'data-filter-modal-hide'
        } data-container__header d-md-block`}
      >
        <div className="row px-4 pt-3 pb-2 d-md-none">
          <div
            className="col-12 col-md pe-md-1 d-flex d-md-none justify-content-end align-items-center gap-2"
            style={{ marginBottom: '-26px' }}
          >
            {/* eslint-disable-next-line react/button-has-type */}
            <button
              id="close-menu-button"
              className="button button--primary button--icon"
              onClick={(e) => {
                e.preventDefault();
                setMobileFilters(!mobileFilters);
              }}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_3703_676"
                  style={{ maskType: 'alpha' }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="25"
                  height="25"
                >
                  <rect
                    x="0.294922"
                    y="0.341797"
                    width="24"
                    height="24"
                    fill="#D9D9D9"
                  />
                </mask>
                <g mask="url(#mask0_3703_676)">
                  <path
                    d="M6.69492 19.3418L5.29492 17.9418L10.8949 12.3418L5.29492 6.7418L6.69492 5.3418L12.2949 10.9418L17.8949 5.3418L19.2949 6.7418L13.6949 12.3418L19.2949 17.9418L17.8949 19.3418L12.2949 13.7418L6.69492 19.3418Z"
                    fill="white"
                  />
                </g>
              </svg>
            </button>
          </div>
        </div>
        <div className="row px-4 pt-3 pb-2">
          <div className="col-12 col-md pe-md-1 mb-3 mb-md-0 d-none d-md-block">
            <p className="heading-h6 mb-1">Sorterat på</p>
            <select
              value={orderBy}
              onChange={(e) => {
                setOrderBy(e.target.value);
                setPlayerLimit(20);
              }}
              className="select"
            >
              {playerFilterOptions?.map((option) => (
                <option value={option?.key}>{option?.name}</option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
            <p className="heading-h6 mb-1">Lag</p>
            <select
              value={team}
              onChange={(e) => {
                setTeam(e.target.value);
                setPlayerLimit(20);
              }}
              className="select"
            >
              {playerTeams?.map((t) => (
                <option value={t.teamAbbrv}>{t.teamDisplayName}</option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
            <p className="heading-h6 mb-1">Position</p>
            <select
              value={position}
              onChange={(e) => {
                setPosition(e.target.value);
                setPlayerLimit(20);
              }}
              className="select"
            >
              {Array.from(playerPositions).map((pos) => (
                <option value={pos}>
                  {pos !== 'Alla positioner'
                    ? translatePosition(pos)
                    : 'Alla positioner'}
                </option>
              ))}
            </select>
          </div>
          {/*
        <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
          <p className="heading-h6 mb-1">Nationalitet</p>
          <select
            value={nationality}
            onChange={(e) => {
              setNationality(e.target.value);
              setPlayerLimit(20);
            }}
            className="select"
          >
            {Array.from(playerNationalities).map((nat) => (
              <option value={nat}>
                {nat !== 'Alla nationaliteter'
                  ? translateCountry(nat)
                  : 'Alla nationaliteter'}
              </option>
            ))}
          </select>
        </div>
        */}
          <div className="col-12 col-md pe-md-1 mb-3 mb-md-0">
            <p className="heading-h6 mb-1">Säsong</p>
            <select
              value={season}
              onChange={(e) => {
                setSeason(e.target.value);
                setPlayerLimit(20);
              }}
              className="select"
            >
              {seasons?.map((s) =>
                Number(s?.configSeasonStartYear) >= 2019 ? (
                  <option value={s?.configSeasonStartYear}>
                    {s?.configSeasonStartYear}
                  </option>
                ) : (
                  ''
                )
              )}
            </select>
          </div>
        </div>
      </div>
    </>
  );
}
export default PlayersFilter;
